<template>
  <inertia-link
    :href="$route('search', {'filter[type]': category.mediaType})"
    class="w-full rounded-item text-white cursor-pointer shadow-lg relative overflow-hidden">
    <div class="flex items-center lg:items-start relative py-8 px-12 2xl:px-8 z-10 bg-yank bg-opacity-90 hover:bg-opacity-25 transition duration-300 w-full h-full group">
      <div
        class="flex justify-center items-center rounded-full w-20 h-20 lg:h-28 lg:w-28 mr-10 2xl:mr-5 flex-shrink-0 border group-hover:opacity-0 transition duration-300"
        :class="`border-${category.color}`">
        <PhotosIcon v-if="category.name === 'Photos'"/>
        <VideosIcon v-else-if="category.name === 'Videos'"/>
        <SocialIcon v-else-if="category.name === 'Social Media'"/>
        <ScreenIcon v-else/>
      </div>
      <div class="group-hover:opacity-0 transition duration-300">
        <div class="flex items-center space-x-3">
          <h4 class="font-bold text-2xl lg:text-3xl 2xl:text-base">{{ category.name }}</h4>
          <!--        <span class="rounded-full border-2 border-white px-4 py-1 text-xs">-->
          <!--          {{ mediaCount }}-->
          <!--        </span>-->
        </div>
        <p class="mt-3 text-sm lg:text-md">{{ category.description }}</p>
      </div>
    </div>
    <div class="absolute z-0 inset-0">
      <img :src="category.image" class="object-cover w-full h-full" />
    </div>
  </inertia-link>
</template>
<script>
import ScreenIcon from "@/components/svg/ScreenIcon";
import PhotosIcon from "@/components/svg/PhotosIcon";
import SocialIcon from "@/components/svg/SocialIcon";
import VideosIcon from "@/components/svg/VideosIcon";
export default {
  name: 'CategoryCard',

  components: {PhotosIcon, ScreenIcon, SocialIcon, VideosIcon},

  props: {
    category: Object
  },

  computed: {
    mediaCount() {
      return this.$page.props.mediaCounts[this.category.mediaType]
    }
  }
}
</script>
